// extracted by mini-css-extract-plugin
export default {"dialog":"DuplicateEmailDialog_dialog__EAeox"};